import { Button, FormControl, MenuItem, Select, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { styled } from "@mui/material/styles"

export const StyledButton = styled(Button)(({theme}) => ({
    marginLeft: theme.spacing(1), // Equivalent to ml: 1
    backgroundColor: '#002677',
    alignSelf: 'flex-start',
    whiteSpace: 'nowrap',
    padding: '0.2em 0.5em',
    color: '#fff',
}))

export const StyledTextfield = styled(TextField)(({theme}) => ({
    marginLeft: theme.spacing(1), // Equivalent to ml: 1
  '& .MuiInputBase-input': {
    padding: '0.2em 0.5em', // Padding inside the input field

},
'& .MuiInputBase-input::placeholder': {
     fontSize: '0.8em'
}
,
  '& .MuiInputLabel-root': {
    marginTop: '-3% !important', // Adjusts the label position
  },
}))

export const StyledSelect = styled(Select)(({theme}) => ({
    '& .MuiSelect-select': { 
        padding: '0.2em 0.5em ',
        fontSize: '0.8em'
    }
}))

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    fontSize: '0.8em', // Set the font size
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
    display: 'inline-block',
    '& input': {
        padding: '0.2em 0.5em !important',
        fontSize: '0.8em'
    },
    

    '& .MuiInputLabel-root': {
        marginTop: '-6% !important',
    },

    '& .MuiInputAdornment-root':{
        maxHeight: '1.8em'
    }
}))

export const GenericSelect = ({
    value,
    options,
    onChange,
    labelId = "generic-select-label",
    id = "generic-select",
    sx = { mx: 1, width: 120 },
    ...rest
}) => (
    <FormControl sx={sx}>
        <StyledSelect
            labelId={labelId}
            id={id}
            value={value}
            onChange={onChange}
            {...rest}
        >
            {options.map(opt => (
                <StyledMenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                </StyledMenuItem>
            ))}
        </StyledSelect>
    </FormControl>
);

